import { createContext } from "react";

export const StripeContext = createContext({});
